import { useState, useEffect } from "react";
import { loadProductListBudgetPlan } from "../services/Product";

const useProductListBudgetPlan = (editID) => {

    const [productList, setProductList] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedProductID, setSelectedProductID] = useState(null);
    const [isMaterialCategoryDataLoaded, setIsMaterialCategoryDataLoaded] = useState(false);

    // Fetch department data
    const fetchProduct = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {
            const data = await loadProductListBudgetPlan(para);
            if (data && data.length > 0) {
                setProductList(data);

                if (selectedID === 0) {
                    setSelectedProduct([]);
                    setSelectedProductID([]);
                    setIsMaterialCategoryDataLoaded(true);
                }
                else {
                    const initialMaterialCategory = data.find((dept) => dept.id === selectedID);
                    // const initialDepartment = data.find((dept) => dept.id === selectedID) || data[0];
                    if (initialMaterialCategory) { // ✅ Corrected check
                        setSelectedProduct(initialMaterialCategory);
                        setSelectedProductID(initialMaterialCategory.id);
                        setIsMaterialCategoryDataLoaded(true);
                    }
                }
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isMaterialCategoryDataLoaded && editID === 0) {
            fetchProduct();
        }
    }, [isMaterialCategoryDataLoaded, editID]);

    // Function to load department based on selected ID
    const loadProductByID = async (selectedID) => {
        await fetchProduct(selectedID);
    };

    return {
        productList,
        selectedProduct,
        selectedProductID,
        setSelectedProduct,
        setSelectedProductID,
        loadProductByID,
    };
};

export default useProductListBudgetPlan;